import React, { useEffect, useRef, useState } from 'react';
import { createChart } from 'lightweight-charts';
import s from './CryptoChart.module.sass';

export const CryptoChart = ({ isUnmounting }) => {
    const chartContainerRef = useRef();
    const [candleSeries, setCandleSeries] = useState(null);

    useEffect(() => {
        const chart = createChart(chartContainerRef.current, {
            width: 620,
            height: 400,
            layout: {
                backgroundColor: '#ffffff',
                textColor: 'rgba(33, 56, 77, 1)',
            },
            grid: {
                vertLines: {
                    color: 'rgba(197, 203, 206, 0.5)',
                },
                horzLines: {
                    color: 'rgba(197, 203, 206, 0.5)',
                },
            },
            crosshair: {
                mode: 'normal',
            },
            rightPriceScale: {
                borderColor: 'rgba(197, 203, 206, 0.8)',
            },
            timeScale: {
                borderColor: 'rgba(197, 203, 206, 0.8)',
                timeVisible: true,
                secondsVisible: false,
            },
        });

        if (isUnmounting) {
            chart.remove();
        }

        const series = chart.addCandlestickSeries({
            upColor: '#4bffb5',
            downColor: '#ff4976',
            borderDownColor: '#ff4976',
            borderUpColor: '#4bffb5',
            wickDownColor: '#ff4976',
            wickUpColor: '#4bffb5',
        });

        setCandleSeries(series);
    }, [isUnmounting]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('/api/binance/klines?symbol=BNBUSDT&interval=1h&limit=500');
                const data = await response.json();

                // Устанавливаем все свечи, кроме последней
                const cdata = data.slice(0, -1).map(d => ({
                    time: d[0] / 1000,
                    open: parseFloat(d[1]),
                    high: parseFloat(d[2]),
                    low: parseFloat(d[3]),
                    close: parseFloat(d[4]),
                }));

                if (candleSeries) {
                    candleSeries.setData(cdata);

                    // Инициализация последней свечи с фиксированными тенями
                    const lastData = data[data.length - 1];
                    const open = parseFloat(lastData[1]);
                    let close = open * 1.01; // Закрытие на уровне +1% от открытия

                    // Фиксированные значения теней
                    const fixedHigh = open * 1.015; // 1.5% выше открытия
                    const fixedLow = open * 0.985;  // 1.5% ниже открытия

                    // Устанавливаем начальную последнюю свечу с фиксированными тенями
                    const lastCandle = {
                        time: lastData[0] / 1000,
                        open: open,
                        high: fixedHigh,
                        low: fixedLow,
                        close: close,
                    };

                    candleSeries.update(lastCandle);

                    // Колебания закрытия последней свечи, не изменяя тени
                    const intervalId = setInterval(() => {
                        const fluctuation = open * 0.005 * (Math.random() - 0.5); // ±0.5% колебание
                        close = open * 1.01 + fluctuation; // Новый close с колебанием

                        candleSeries.update({
                            time: lastCandle.time,
                            open: lastCandle.open,
                            high: fixedHigh, // Фиксированный high
                            low: fixedLow,   // Фиксированный low
                            close: close,
                        });
                    }, 1000);

                    // Очищаем интервал при размонтировании компонента
                    return () => clearInterval(intervalId);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData(); // Первый вызов для инициализации данных
    }, [candleSeries]);

    return <div ref={chartContainerRef} className={s.chartContainer}></div>;
};
